import main from './page/main';
import guide from './page/guide';
import intro from './page/intro';
import maps from './page/maps';
import contents from './page/contents';

new nc.promokit.Preloader({
    'game': 'bns',
    'delay': 1000,
    'image': [
		'/promo/bns/history/2018/180912_awaken/img/common/bg-gnb.png',
		'/promo/bns/history/2018/180912_awaken/img/common/btn_movie_play.png',
		'/promo/bns/history/2018/180912_awaken/img/common/btn_remote_off.png',
		'/promo/bns/history/2018/180912_awaken/img/common/btn_remote_on.png',
		'/promo/bns/history/2018/180912_awaken/img/common/footer.png',
		'/promo/bns/history/2018/180912_awaken/img/common/gnb-off.png',
		'/promo/bns/history/2018/180912_awaken/img/common/gnb-on.png',
		'/promo/bns/history/2018/180912_awaken/img/common/header_etc_bg.png',
		'/promo/bns/history/2018/180912_awaken/img/common/layer_close.png',
		'/promo/bns/history/2018/180912_awaken/img/common/logo.png',
		'/promo/bns/history/2018/180912_awaken/img/common/mask_header.png',
		'/promo/bns/history/2018/180912_awaken/img/common/player-pause.png',
		'/promo/bns/history/2018/180912_awaken/img/common/remote_menu_bg.png',
		'/promo/bns/history/2018/180912_awaken/img/common/sdw_screen.png',
		'/promo/bns/history/2018/180912_awaken/img/contents/bg_contents.jpg',
		'/promo/bns/history/2018/180912_awaken/img/contents/contents_tit.png',
		'/promo/bns/history/2018/180912_awaken/img/contents/contents_txt.png',
		'/promo/bns/history/2018/180912_awaken/img/contents/content_char.png',
		'/promo/bns/history/2018/180912_awaken/img/contents/content_con_1.png',
		'/promo/bns/history/2018/180912_awaken/img/contents/content_con_2.png',
		'/promo/bns/history/2018/180912_awaken/img/guide/bg_guide.jpg',
		'/promo/bns/history/2018/180912_awaken/img/guide/guide_tit.png',
		'/promo/bns/history/2018/180912_awaken/img/guide/guide_txt.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/bg_class_left.jpg',
		'/promo/bns/history/2018/180912_awaken/img/intro/bg_class_right.jpg',
		'/promo/bns/history/2018/180912_awaken/img/intro/bg_intro.jpg',
		'/promo/bns/history/2018/180912_awaken/img/intro/btn_detail.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_10_1_c.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_10_1_f_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_10_1_f_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_10_2_c.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_10_2_f_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_10_2_f_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_10_2_f_3.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_11_1_c.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_11_1_f_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_11_1_f_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_11_1_f_3.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_11_2_c.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_11_2_f_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_11_2_f_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_11_2_f_3.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_1_1_c.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_1_1_f_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_1_1_f_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_1_2_c.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_1_2_f_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_1_2_f_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_1_2_f_3.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_1_2_f_4.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_2_1_c.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_2_1_f_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_2_2_c.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_2_2_f_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_2_2_f_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_2_2_f_3.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_3_1_c.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_3_1_f_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_3_1_f_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_3_2_c.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_3_2_f_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_3_2_f_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_4_1_c.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_4_1_f_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_4_1_f_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_4_1_f_3.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_4_2_c.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_4_2_f_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_4_2_f_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_4_2_f_3.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_5_1_c.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_5_1_f_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_5_1_f_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_5_1_f_3.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_5_1_f_4.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_5_1_f_5.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_5_2_c.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_5_2_f_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_5_2_f_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_5_2_f_3.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_6_1_c.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_6_1_f_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_6_1_f_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_6_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_6_2_c.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_6_2_f_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_7_1_c.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_7_1_f_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_7_1_f_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_7_1_f_3.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_7_2_c.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_7_2_f_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_7_2_f_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_8_1_c.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_8_1_f_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_8_1_f_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_8_2_c.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_8_2_f_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_8_2_f_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_8_2_f_3.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_8_2_f_4.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_9_1_c.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_9_1_f_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_9_1_f_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_9_2_c.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_9_2_f_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_9_2_f_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_char_9_2_f_3.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_tit_10_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_tit_10_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_tit_11_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_tit_11_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_tit_1_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_tit_1_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_tit_2_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_tit_2_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_tit_3_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_tit_3_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_tit_4_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_tit_4_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_tit_5_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_tit_5_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_tit_6_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_tit_6_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_tit_7_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_tit_7_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_tit_8_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_tit_8_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_tit_9_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_tit_9_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_txt_10_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_txt_10_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_txt_11_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_txt_11_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_txt_1_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_txt_1_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_txt_2_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_txt_2_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_txt_3_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_txt_3_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_txt_4_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_txt_4_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_txt_5_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_txt_5_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_txt_6_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_txt_6_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_txt_7_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_txt_7_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_txt_8_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_txt_8_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_txt_9_1.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/class_txt_9_2.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/intro_tit.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/intro_txt.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/navi_class_01.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/navi_class_01_off.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/navi_class_01_on.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/navi_class_02.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/navi_class_02_off.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/navi_class_02_on.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/navi_class_03.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/navi_class_03_off.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/navi_class_03_on.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/navi_class_04.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/navi_class_04_off.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/navi_class_04_on.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/navi_class_05.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/navi_class_05_off.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/navi_class_05_on.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/navi_class_06.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/navi_class_06_off.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/navi_class_06_on.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/navi_class_07.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/navi_class_07_off.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/navi_class_07_on.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/navi_class_08.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/navi_class_08_off.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/navi_class_08_on.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/navi_class_09.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/navi_class_09_off.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/navi_class_09_on.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/navi_class_10.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/navi_class_10_off.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/navi_class_10_on.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/navi_class_11.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/navi_class_11_off.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/navi_class_11_on.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/sub_navi.png',
		'/promo/bns/history/2018/180912_awaken/img/intro/sub_navi_on.png',
		'/promo/bns/history/2018/180912_awaken/img/main/badge_event.png',
		'/promo/bns/history/2018/180912_awaken/img/main/btn_play.png',
		'/promo/bns/history/2018/180912_awaken/img/main/efc_title_1.png',
		'/promo/bns/history/2018/180912_awaken/img/main/efc_title_2.png',
		'/promo/bns/history/2018/180912_awaken/img/main/ico_scroll.png',
		'/promo/bns/history/2018/180912_awaken/img/main/main_comming.png',
		'/promo/bns/history/2018/180912_awaken/img/main/main_date.png',
		'/promo/bns/history/2018/180912_awaken/img/main/main_stit.png',
		'/promo/bns/history/2018/180912_awaken/img/main/main_stit_line.png',
		'/promo/bns/history/2018/180912_awaken/img/main/main_tit.png',
		'/promo/bns/history/2018/180912_awaken/img/maps/bg_maps.jpg',
		'/promo/bns/history/2018/180912_awaken/img/maps/bg_map_area.png',
		'/promo/bns/history/2018/180912_awaken/img/maps/bg_map_layer.jpg',
		'/promo/bns/history/2018/180912_awaken/img/maps/bg_map_layer2.jpg',
		'/promo/bns/history/2018/180912_awaken/img/maps/img_map_01_01.jpg',
		'/promo/bns/history/2018/180912_awaken/img/maps/img_map_01_02.jpg',
		'/promo/bns/history/2018/180912_awaken/img/maps/img_map_01_03.jpg',
		'/promo/bns/history/2018/180912_awaken/img/maps/img_map_01_04.jpg',
		'/promo/bns/history/2018/180912_awaken/img/maps/img_map_01_05.jpg',
		'/promo/bns/history/2018/180912_awaken/img/maps/img_map_02_01.jpg',
		'/promo/bns/history/2018/180912_awaken/img/maps/img_map_02_02.jpg',
		'/promo/bns/history/2018/180912_awaken/img/maps/img_map_02_03.jpg',
		'/promo/bns/history/2018/180912_awaken/img/maps/img_map_03_01.jpg',
		'/promo/bns/history/2018/180912_awaken/img/maps/img_map_03_02.jpg',
		'/promo/bns/history/2018/180912_awaken/img/maps/img_map_03_03.jpg',
		'/promo/bns/history/2018/180912_awaken/img/maps/img_map_04_01.jpg',
		'/promo/bns/history/2018/180912_awaken/img/maps/img_map_04_02.jpg',
		'/promo/bns/history/2018/180912_awaken/img/maps/img_map_05_01.jpg',
		'/promo/bns/history/2018/180912_awaken/img/maps/img_map_05_02.jpg',
		'/promo/bns/history/2018/180912_awaken/img/maps/img_map_05_03.jpg',
		'/promo/bns/history/2018/180912_awaken/img/maps/img_map_05_04.jpg',
		'/promo/bns/history/2018/180912_awaken/img/maps/img_map_05_05.jpg',
		'/promo/bns/history/2018/180912_awaken/img/maps/img_map_06_01.jpg',
		'/promo/bns/history/2018/180912_awaken/img/maps/img_map_06_02.jpg',
		'/promo/bns/history/2018/180912_awaken/img/maps/img_map_06_03.jpg',
		'/promo/bns/history/2018/180912_awaken/img/maps/img_map_06_04.jpg',
		'/promo/bns/history/2018/180912_awaken/img/maps/img_map_06_05.jpg',
		'/promo/bns/history/2018/180912_awaken/img/maps/img_map_07_01.jpg',
		'/promo/bns/history/2018/180912_awaken/img/maps/img_map_07_02.jpg',
		'/promo/bns/history/2018/180912_awaken/img/maps/maps_tit.png',
		'/promo/bns/history/2018/180912_awaken/img/maps/maps_txt.png',
		'/promo/bns/history/2018/180912_awaken/img/maps/map_area_1_off.png',
		'/promo/bns/history/2018/180912_awaken/img/maps/map_area_1_on.png',
		'/promo/bns/history/2018/180912_awaken/img/maps/map_area_2_off.png',
		'/promo/bns/history/2018/180912_awaken/img/maps/map_area_2_on.png',
		'/promo/bns/history/2018/180912_awaken/img/maps/map_area_3_off.png',
		'/promo/bns/history/2018/180912_awaken/img/maps/map_area_3_on.png',
		'/promo/bns/history/2018/180912_awaken/img/maps/map_area_4_off.png',
		'/promo/bns/history/2018/180912_awaken/img/maps/map_area_4_on.png',
		'/promo/bns/history/2018/180912_awaken/img/maps/map_area_5_off.png',
		'/promo/bns/history/2018/180912_awaken/img/maps/map_area_5_on.png',
		'/promo/bns/history/2018/180912_awaken/img/maps/map_area_6_off.png',
		'/promo/bns/history/2018/180912_awaken/img/maps/map_area_6_on.png',
		'/promo/bns/history/2018/180912_awaken/img/maps/map_area_7_off.png',
		'/promo/bns/history/2018/180912_awaken/img/maps/map_area_7_on.png',
		'/promo/bns/history/2018/180912_awaken/img/maps/mask_layer.png',
		'/promo/bns/history/2018/180912_awaken/img/maps/obj_map_06.png',
		'/promo/bns/history/2018/180912_awaken/img/maps/obj_map_07.png',
		'/promo/bns/history/2018/180912_awaken/img/maps/pager_off.png',
		'/promo/bns/history/2018/180912_awaken/img/maps/pager_on.png',
		'/promo/bns/history/2018/180912_awaken/img/maps/point_btm.png',
		'/promo/bns/history/2018/180912_awaken/img/maps/point_top.png',
		'/promo/bns/history/2018/180912_awaken/img/maps/pop_map_tit_01.png',
		'/promo/bns/history/2018/180912_awaken/img/maps/pop_map_tit_02.png',
		'/promo/bns/history/2018/180912_awaken/img/maps/pop_map_tit_03.png',
		'/promo/bns/history/2018/180912_awaken/img/maps/pop_map_tit_04.png',
		'/promo/bns/history/2018/180912_awaken/img/maps/pop_map_tit_05.png',
		'/promo/bns/history/2018/180912_awaken/img/maps/pop_map_tit_06.png',
		'/promo/bns/history/2018/180912_awaken/img/maps/pop_map_tit_07.png',
		'/promo/bns/history/2018/180912_awaken/img/maps/pop_map_txt_06.png',
		'/promo/bns/history/2018/180912_awaken/img/maps/pop_map_txt_07.png',
		'/promo/bns/history/2018/180912_awaken/img/maps/reward_00.png'
    ]
});

const layoutAction = {
    [0]: {context: main, name: 'scene1'},
    [1]: {context: guide, name: 'scene2'},
    [2]: {context: intro, name: 'scene3'},
    [3]: {context: maps, name: 'scene4'},
	[4]: {context: contents, name: 'scene5'}
};

var sceneLayoutIndex;

var sceneBoxControls = (function (window, document, $, undefined) {

    var $list = $(".gnb").children("li.open");
    var remoteChk = true;

    var init = function() {
        controls();
        sceneLayoutIndex = new nc.ui.SceneBox({
            selector: '#scene-box',
            render: 0,

            onCompleteCallback () {
                layoutAction[sceneLayoutIndex.detect.state.nowLayout].context.onComplete();
                $list.removeClass("on");
                $list.eq(sceneLayoutIndex.detect.state.nowLayout).addClass("on");
            },
            onStartCallback () {
                layoutAction[sceneLayoutIndex.detect.state.nowLayout].context.onStart();
				if(sceneLayoutIndex.detect.state.nowLayout!=0){
                    main.closeAnimation();
					main.mainResetMovie();
                }
                if(sceneLayoutIndex.detect.state.nowLayout!=1){
                    guide.guideRestMedia();
                }
                if(remoteChk){
                    glaRemote.remoteAct(false);
                    remoteChk = false;
                }else{
                    glaRemote.remoteAct(true);
                }
            },
            onAnimation () {
                layoutAction[sceneLayoutIndex.detect.state.to].context.onAnimation();
            },
        });
    };

    function controls(){
        $list.on("click", function(){
            var target = $(this).index();
			var isIntro = intro.checkDetail();
            if(sceneLayoutIndex.detect.state.nowLayout==target){
				if(target == 2){
					if(isIntro){
						intro.onStart();
						intro.onAnimation();
						return
					}
					return
				}else{
					return
				}
			}
            navigation(target);
        });
    }

    function navigation(target){
        sceneLayoutIndex.render(target);
    }

    return {
        init:init
    };

})(window, document, $);

var glaRemote = (function (window, document, $, undefined) {

    var $btnArrow = $(".btn_remote"), $remoteWrap = $(".remote_wrap"), $remote = $(".remote_nav").find("li");

    var init = function() {
        $btnArrow.on("click", function(){
            var flag = $remoteWrap.hasClass("on");
            remoteAct(flag);
			//alertMessage();
        });
        // $remote.on("click", function(){
        //     var target = $(this).index();
        //     alertMessage(target);
        // });
    };

    function alertMessage(){
        alert("9월 12일 확인이 가능합니다.");
    }

    function remoteAct(flag){
        if(!flag){
			$btnArrow.addClass("on");
            $remoteWrap.addClass("on");
        }else{
			$btnArrow.removeClass("on");
            $remoteWrap.removeClass("on");
        }
    }

    return {
        init:init,
        remoteAct:remoteAct
    };

})(window, document, $);
$(window).resize(function(){
	let container = $('.container');
	let originWidth = container.width();
	let originHeight = container.height();

	TweenMax.set($('[data-scene]'), {
		clip: "rect(0, " + originWidth + ", " + originHeight + ", 0)"
	});
});
$(document).on('preloadend', function(){
	$('#container').css('opacity',1);

    main.mainInit();

	glaRemote.init();

    sceneBoxControls.init();

	maps.mapInit();

});



// WEBPACK FOOTER //
// ./src/js/index.js